AccountSetupModalCtrl.$inject = ['$rootScope', '$scope', 'CurrentAccount']

export default function AccountSetupModalCtrl($rootScope, $scope, CurrentAccount) {

  $scope.currentAccount = CurrentAccount;

  $scope.submitButtonStates = {
    false: '',
    true: 'Submitting... <i class="font-icon-sm icon-spinner icon-spin">'
  };
};



// WEBPACK FOOTER //
// ./project/modals/account-setup/account-setup.controller.js